<template>
  <div class="classification">
    <div class="class-box flex-1">
      <div class="box-title">分类区</div>
      <div v-for="(item, index) in classList" :key="item.id" class="drag-class">
        <!-- <div class="drag-text">{{item.content.text}}</div> -->
        <div
          class="drag-text leading-6 pr-4 pt-4 text-black textImg"
          v-html="transformHtml(item.content.richText || item.content.text)"
        ></div>

        <div class="h-full drag-box" v-if="item.classItemList && item.classItemList.length">
          <transition-group tag="div" class="h-full">
            <div v-for="(item0, index0) in item.classItemList" :key="item0.row_id">
              <div v-if="item0.col_id == item.id">
                <div class="classification-item">
                  <div class="inline-block ml-2">
                    <el-popover
                      ref="popo"
                      placement="left"
                      title="请选择分类"
                      width="200"
                      trigger="click"
                      content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。"
                    >
                      <el-select
                        v-model="value"
                        placeholder="请选择"
                        @change="handleAnswerList(item, item0, value, index0, index)"
                      >
                        <el-option
                          v-for="item in classList"
                          :key="item.id"
                          :label="item.content.text"
                          :value="item.id"
                          class="options"
                        >
                        </el-option>
                      </el-select>
                      <div
                        slot="reference"
                        class="leading-6 pr-4 text-black textImg"
                        v-html="transformHtml(item0.content.richText || item0.content.text)"
                      ></div>
                    </el-popover>
                  </div>
                </div>
              </div>
            </div>
          </transition-group>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import isEqual from 'lodash.isequal'
import uniqWith from 'lodash.uniqwith'
import { saveArr } from '../public/index.js'

export default {
  name: 'Classification',
  props: {
    rowData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 需要更新的 数组
    updateArr: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      options: [],
      value: '',
      //分类项
      classList: this.rowData.questionDetails.issue.items.map(col => {
        col.classItemList = this.getAnswerList()
        return col
      })
    }
  },
  computed: {},
  inject: ['transformHtml'],
  methods: {
    getAnswerList() {
      let arr = []
      this.rowData.questionDetails.issue.rows.forEach((item, index) => {
        this.rowData.items.forEach((item1, index1) => {
          if (item1.rowId == item.row_id) {
            item.col_id = item1.colId
          }
        })
        arr.push(item)
      })
      return arr
    },
    handleAnswerList(item, item0, value, itemIndex, index) {
      console.log(item, item0)
      if (value == item0.col_id) {
        return
      }
      console.log(value, itemIndex, index)
      let curItem = this.classList[index].classItemList[itemIndex]
      console.log(curItem)
      let curIndex = ''
      this.classList.forEach((item, index) => {
        if (item.id == value) {
          curIndex = index
        }
      })
      curItem.col_id = value
      this.classList[curIndex].classItemList.push(curItem)
      this.classList[curIndex].classItemList = uniqWith(this.classList[curIndex].classItemList, isEqual)
      this.classList[index].classItemList.splice(itemIndex, 1)

      this.value = ''
      //排除此类以外的数据
      this.classList.forEach((item, index) => {
        item.classItemList = item.classItemList.filter((item1, index1) => {
          if (item.id == item1.col_id) {
            return item1
          }
        })
        item.classItemList.forEach((item2, index2) => {
          this.rowData.items.forEach((item3, index3) => {
            if (item3.rowId == item2.row_id) {
              item3.colId = item2.col_id
            }
          })
        })
      })
      // this.updateArr.push(this.rowData)
      this.saveArr()
    },
    saveArr
  },
  created() {},
  mounted() {}
}
</script>
<style lang="scss" scoped>
.textImg {
  ::v-deepp {
    line-height: 40px;
  }
  ::v-deepimg {
    width: 80px !important;
    height: 80px !important;
  }
}
.options {
  width: 200px;
}
.classification {
  .classification-item {
    border: 1px solid;
    margin: 5px 0;

    @apply border-gray-500;
  }

  .item-box {
    margin-right: 20px;
  }

  .class-box {
    //border: 1px solid #efefef;
    padding: 5px 10px;
    box-sizing: border-box;
    position: relative;
    display: flex;
    flex-direction: column;
  }
  .drag-box {
    min-height: 70px;
    padding: 5px 10px;
  }
  .drag-class {
    border: 1px solid #d8d8d8;
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;
  }
  .drag-text {
    border-bottom: 1px solid #d8d8d8;
    background-color: #f3f4f5;
    text-align: center;
    padding: 0 5px;
  }
  .box-title {
    margin-bottom: 5px;
    color: #8a8a8a;
  }
  .item-drag-box {
    border: 1px solid #dddfe0;
    min-height: 80px;
    padding: 5px 10px;
  }
  .drag-empty {
    min-height: 70px;
    line-height: 70px;
    text-align: center;
    color: #bfc2c2;
  }
}
</style>
